export const layout = {
  HEADER_HEIGHT: 60,
  HEADER_HEIGHT_MOBILE: 60,
  SIDEBAR_WIDTH: 260,
  FOOTER_HEIGHT: 299,
}
